import { render, staticRenderFns } from "./courseware-repo.vue?vue&type=template&id=f88b7b66&"
import script from "./courseware-repo.vue?vue&type=script&lang=js&"
export * from "./courseware-repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports